export const CAPTIONS_TEXT_COLOR = '#85979f';
export const DARK_NAVY_COLOR = '#15284b';
export const DARK_TEXT_COLOR = '#061e3b';
export const LIGHT_GREY_COLOR = '#bbc9cf';
export const LIGHT_VIOLET_COLOR = '#d9dfef';
export const LL_BACKGROUND_COLOR = '#f1f3f4';
export const TABS_COLOR = '#A2A4A7';
